// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-3Fmu","clinicsSelect":"styles_clinicsSelect__35SYD"};